/*
 * NutriProVita collection page — small enhancements around Sense's facets.
 *
 * 1. Sense's vertical facets open only the first <details> group. The design
 *    shows every group expanded; openAll() forces that on load and after any
 *    facets.js re-render (it swaps a filter's innerHTML by id, so [open] state
 *    on the <details> itself survives — we only catch brand-new groups).
 *
 * 2. Mobile: the desktop sidebar doubles as a left slide-in drawer. The
 *    toolbar "Filters" button opens it; the drawer's X, the scrim, and Escape
 *    close it. Sense's own mobile drawer is unused (hidden via CSS).
 */
(function () {
  var LOCK_CLASS = 'npv-filter-lock';
  var OPEN_CLASS = 'npv-drawer-open';

  function openAll() {
    document
      .querySelectorAll(
        '.npv-plp__sidebar details.facets__disclosure-vertical:not([open])'
      )
      .forEach(function (d) {
        d.open = true;
      });
  }

  function drawerEls() {
    return [
      document.querySelector('.npv-plp__sidebar'),
      document.querySelector('.npv-plp__scrim'),
    ].filter(Boolean);
  }

  function openDrawer() {
    drawerEls().forEach(function (el) {
      el.classList.add(OPEN_CLASS);
    });
    document.documentElement.classList.add(LOCK_CLASS);
    openAll();
  }

  function closeDrawer() {
    drawerEls().forEach(function (el) {
      el.classList.remove(OPEN_CLASS);
    });
    document.documentElement.classList.remove(LOCK_CLASS);
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function wireDrawer() {
    document.querySelectorAll('[data-npv-filter-toggle]').forEach(function (btn) {
      if (btn.dataset.npvWired) return;
      btn.dataset.npvWired = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });

    document.querySelectorAll('[data-npv-filter-close]').forEach(function (el) {
      if (el.dataset.npvWired) return;
      el.dataset.npvWired = '1';
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeDrawer();
      });
    });
  }

  ready(function () {
    openAll();
    wireDrawer();

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // Close the drawer once the viewport is back to desktop width.
    var mq = window.matchMedia('(min-width: 750px)');
    var onMq = function () {
      if (mq.matches) closeDrawer();
    };
    if (mq.addEventListener) mq.addEventListener('change', onMq);
    else if (mq.addListener) mq.addListener(onMq);

    // Re-open groups + re-wire after facets.js finishes a filter/sort re-render.
    var filters = document.getElementById('main-collection-filters');
    if (filters) {
      new MutationObserver(function () {
        openAll();
        wireDrawer();
      }).observe(filters, { childList: true, subtree: true });
    }
  });

  document.addEventListener('shopify:section:load', function () {
    openAll();
    wireDrawer();
  });
})();
